import { library } from '@fortawesome/fontawesome-svg-core';
import { 
  faQuestion,
  faCheck,
  faUser,
  faEdit,
  faTrashAlt,
  faPlus,
  faTimes,
  faSave,
  faFilter,
  faCalendarAlt,
  faTag,
  faTags,
  faChartLine,
  faChartPie,
  faChartBar,
  faPercent,
  faPoundSign,
  faUserEdit,
  faCheckCircle,
  faMoneyBill,
  faMoon,
  faSun,
  faPalette,
  faArrowLeft,
  faClock,
  faMoneyBillWave,
  faCalendar,
  faExchangeAlt
} from '@fortawesome/free-solid-svg-icons';

// Register icons used across the application
library.add(
  faQuestion,
  faCheck,
  faUser,
  faEdit,
  faTrashAlt,
  faPlus,
  faTimes,
  faSave,
  faFilter,
  faCalendarAlt,
  faTag,
  faTags,
  faChartLine,
  faChartPie,
  faChartBar,
  faPercent,
  faPoundSign,
  faUserEdit,
  faCheckCircle,
  faMoneyBill,
  faMoon,
  faSun,
  faPalette,
  faArrowLeft,
  faClock,
  faMoneyBillWave,
  faCalendar,
  faExchangeAlt
);
